<load-guard [host]="this">
  <ng-container *ngIf="!ready && !failedToLoad">
    <app-spinner></app-spinner>
  </ng-container>

  <ng-container *ngIf="ready && !failedToLoad">
    <div class="carousel">
      <div>
        <app-carousel class="mobile-display" *ngIf="!carouselSlides || carouselSlides.length > 0">

          <!-- render only one slide on SSR -->
          <ng-container *ngIf="serverSide && carouselSlides">
            <app-carousel-item [responsiveBackgroundImage]="carouselSlides[0].image" [url]="carouselSlides[0].url">
            </app-carousel-item>
          </ng-container>

          <!-- full carousel set (client-side, mobile) -->
          <ng-container *ngIf="!serverSide">
            <ng-container *ngFor="let slide of carouselSlides">
                <ng-container *ngIf="slide.intended_audience.includes(audienceType)">
                  <app-carousel-item [responsiveBackgroundImage]="slide.image" [url]="slide.url">
                  </app-carousel-item>
                </ng-container>
            </ng-container>
          </ng-container>
        </app-carousel>
        <app-carousel class="desktop-display" *ngIf="!carouselSlides || carouselSlides.length > 0">

          <!-- render only one slide on SSR -->
          <ng-container *ngIf="serverSide && carouselSlides">
            <app-carousel-item [responsiveBackgroundImage]="carouselSlides[0].image_desktop" [url]="carouselSlides[0].url">
            </app-carousel-item>
          </ng-container>

          <!-- full carousel set (client-side, desktop) -->
          <ng-container *ngIf="!serverSide">
            <ng-container *ngFor="let slide of carouselSlides">
                <ng-container *ngIf="slide.intended_audience.includes(audienceType)">
                  <app-carousel-item [responsiveBackgroundImage]="slide.image_desktop || slide.image" [url]="slide.url">
                  </app-carousel-item>
                </ng-container>
            </ng-container>
          </ng-container>
        </app-carousel>
      </div>
    </div>

    <div class="page-c2a" *ngIf="onboarding && user">
      <div class="message">
        <span>
          <strong>Welcome {{user.display_name}}!</strong> Get started by picking your favorite topics, shows, and hosts now.
        </span>
      </div>
      <a class="page-action" routerLink="/settings/content/topics">
        Let's Go!
      </a>
    </div>

    <!-- TOPIC ROW TEMPLATE -->

    <ng-template #topicRow let-row="row">
      <div class="home-row" [ngClass]="sizeClass(row).type" [class.tall]="sizeClass(row).tall" [class.has-topic]="row.topic" [class.no-topic]="!row.topic" [attr.data-shutter-order]="i">
        <div class="row-title">
          <label>
            <a *ngIf="row.topic" routerLink="/topics/{{row.topic.slug}}">
              <img src="/assets/icons-2019/topics.svg" />
              {{row.title}}
            </a>
            <ng-container *ngIf="!row.topic">
              <img src="/assets/icons-2019/shows.svg" />
              {{row.title}}
            </ng-container>
          </label>
          <div class="spacer"></div>

          <div class="action-buttons" *ngIf="row.type === 'must_see'">
            <a *ngIf="audienceType === 'member'" href="javascript:;" routerLink="/feed/episodes">
              <i class="fas fa-external-link-alt"></i>
              More
            </a>
            <a *ngIf="audienceType !== 'member'" href="javascript:;" routerLink="/feed/clips">
              <i class="fas fa-external-link-alt"></i>
              More
            </a>
          </div>
          <div class="action-buttons" *ngIf="row.topic">
            <a href="javascript:;" *ngIf="isTopicFollowed(row.topic)" (click)="unfollowTopic(row.topic)">
              <i class="fas fa-star"></i>
              Unfollow
            </a>
            <a href="javascript:;" *ngIf="!isTopicFollowed(row.topic)" (click)="followTopic(row.topic)">
              <i class="far fa-star"></i>
              Follow
            </a>

            <a routerLink="/topics/{{row.topic.slug}}">
              <i class="fas fa-external-link-alt"></i>
              More
            </a>
          </div>
        </div>
        <div class="home-row-items">
          <a *ngFor="let item of row.topic_items; index as i"
            [routerLink]="linkForTopicItem(item)"
            class="home-row-item"
            [attr.data-shutter-order]="i">

            <div class="thumbnail-box" [responsiveBackgroundImage]="item.thumbnail" [widthFactor]="0.33">
                <tyt-playback-status-bar *ngIf="item.type === 'vod'" [playlist]="playlistForTopicItem(item)" [itemId]="item.vod_id"></tyt-playback-status-bar>
            </div>

            <div class="title-row">
              <div class="brand-icon" [responsiveBackgroundImage]="item.brand_logo" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></div>
              <div class="title-row-info">
                <div class="brand-name">{{item.brand_name}}</div>
                <div class="title">
                    {{item.title | summarize}}
                </div>
                <div class="tagline">
                  <tyt-content-badge [type]="badgeTypeForTopicItem(item)"
                    [unlocked]="item.premium_unlocked" [premium]="item.premium"></tyt-content-badge>

                  <ul class="facts">
                    <li><time>{{item.date | date: 'MMMM d'}}</time></li>
                    <li *ngIf="item.duration && item.duration > 0">{{item.duration | duration}}</li>
                    <li>
                      <tyt-comments-count [identifier]="spotIdForTopicItem(item)"></tyt-comments-count>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </ng-template>


    <!-- HOME ROWS -->

    <div class="home-rows" *ngIf="homeRows">
      <ng-container *ngFor="let row of homeRows; index as i">
        <ng-container [ngSwitch]="row.type">
          
          <!-- NEWSLETTER -->

          <ng-container *ngSwitchCase="'newsletter'">
            <div class="home-row single tall" [attr.data-shutter-order]="i">
              <div class="row-title">
                <label>
                  <img  src="/assets/icons-2019/newsletters.svg" />
                  Newsletter
                </label>
              </div>
              <tyt-newsletter-module></tyt-newsletter-module>
            </div>
          </ng-container>

          <!-- TUNE IN -->
          <ng-container *ngSwitchCase="'tune-in'">
            <div class="home-row single" [attr.data-shutter-order]="i">
              <div class="row-title">
                <label>
                  <a routerLink="/about/announcement">
                    <img src="/assets/icons-2019/topics.svg" />
                    Announcements
                  </a>
                </label>
              </div>
              <tyt-announcements-block [showHeader]="false"></tyt-announcements-block>
            </div>
            <div class="home-row single" [attr.data-shutter-order]="i">
              <tyt-watch-on></tyt-watch-on>
            </div>
          </ng-container>

          <!-- TOPIC ROWS -->

          <ng-container *ngSwitchCase="'topic'">
            <ng-container *ngTemplateOutlet="topicRow; context: { row: row }"></ng-container>
          </ng-container>

          <!-- MUST SEE -->

          <ng-container *ngSwitchCase="'must_see'">
            <ng-container *ngTemplateOutlet="topicRow; context: { row: row }"></ng-container>

              <div class="home-row single" [attr.data-shutter-order]="i">
                <div class="row-title">
                  <label>
                    <a routerLink="/live/schedule">
                      <img src="/assets/icons-2019/shows.svg" />
                      Live Schedule 
                    </a>
                  </label>
                </div>
                <tyt-todays-live-schedule></tyt-todays-live-schedule>
              </div>

              <div *ngIf="poll" class="home-row single" [attr.data-shutter-order]="i">
                <tyt-featured-card-poll [poll]="poll"></tyt-featured-card-poll>
              </div>

              <div *ngIf="petition" class="home-row single" [attr.data-shutter-order]="i">
                <tyt-featured-card-poll [poll]="petition"></tyt-featured-card-poll>
              </div>

              <div *ngIf="!user" class="home-row single" [attr.data-shutter-order]="i">
                  <tyt-free-account-benefits></tyt-free-account-benefits>
              </div>
              <div *ngIf="user && !user.entitled" class="home-row single" [attr.data-shutter-order]="i">
                  <tyt-registration-benefits></tyt-registration-benefits>
              </div>

              <div *ngIf="user && (!playbackSessions || playbackSessions.length > 0)" class="home-row single" [attr.data-shutter-order]="i">
                <div class="row-title">
                  <label>
                    <img src="/assets/icons-2019/shows.svg" />
                    Continue Watching
                  </label>
                </div>
                <ng-container *ngIf="!playbackSessions">
                  <app-spinner style="flex-grow: 1;" [inline]="true"></app-spinner>
                </ng-container>
                <div class="home-row-items">
                  <ng-container *ngIf="playbackSessions">
                    <ng-container  *ngFor="let playbackSession of limitArray(playbackSessions, 3)">
                      <ng-container *ngFor="let vod of mainVodArrayOfPlaybackSession(playbackSession)">
                        <a [routerLink]="linkForVod(playbackSession.production, vod)" class="home-row-item">

                          <div class="title-row">
                            <div class="brand-icon" [responsiveBackgroundImage]="playbackSession.production.show.logo_square" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></div>
                            <div class="title-row-info">
                              <div class="brand-name">{{playbackSession.production.show.name}}</div>
                              <div class="title">
                                  {{vod.title | summarize}}
                              </div>
                              <div class="tagline">
                                <tyt-content-badge type="episode"
                                  [unlocked]="unlockedStatusOfVod(vod)" [premium]="vod.is_premium"></tyt-content-badge>

                                <ul class="facts">
                                  <li><time>{{playbackSession.production.date | date: 'MMMM d'}}</time></li>
                                  <li *ngIf="vod.duration && vod.duration > 0">{{vod.duration | duration}}</li>
                                  <li>
                                    <tyt-comments-count [identifier]="'vod_' + vod.id"></tyt-comments-count>
                                  </li>
                                </ul>
                              </div>
                              <tyt-playback-status-bar [session]="playbackSession" visibility="always"></tyt-playback-status-bar>
                            </div>
                          </div>
                        </a>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
          </ng-container>

          <!-- ELECTION -->

          <ng-container *ngSwitchCase="'election'">
            <div *ngIf="candidates.length" class="home-row full" [attr.data-shutter-order]="i">
              <div class="row-title">
                <label><a routerLink="/feed/candidates">
                  <img src="/assets/icons-2019/candidates.svg" />
                  2020 Presidential Race
                </a></label>
                <div class="spacer"></div>
                <div class="action-buttons">
                  <a routerLink="/feed/candidates">
                    <i class="fas fa-external-link-alt"></i>
                    More
                  </a>
                </div>
              </div>
              <div class="home-row-items">
                  <ng-container  *ngFor="let candidate of limitArray(candidates, 6)">
                    <ng-container *ngFor="let vod of [ mainVodOfProduction(candidate) ]">
                      <a [routerLink]="linkForVod(candidate, vod)" class="home-row-item">

                        <div class="thumbnail-box" [responsiveBackgroundImage]="vod.thumbnail_landscape1 || candidate.thumbnail_landscape1" [widthFactor]="0.33">
                            <tyt-playback-status-bar [playlist]="playlistForMainVodOfProduction(candidate)" [item]="vod"></tyt-playback-status-bar>
                        </div>

                        <div class="title-row">
                          <div class="brand-icon" [responsiveBackgroundImage]="candidate.show.logo_square" [widthFactor]="0.1" [mobileWidthFactor]="0.1"></div>
                          <div class="title-row-info">
                            <div class="brand-name">{{candidate.show.name}}</div>
                            <div class="title">
                                {{vod.title | summarize}}
                            </div>
                            <div class="tagline">
                              <tyt-content-badge type="episode"
                                [unlocked]="unlockedStatusOfVod(vod)" [premium]="vod.is_premium"></tyt-content-badge>

                              <ul class="facts">
                                <li><time>{{candidate.date | date: 'MMMM d'}}</time></li>
                                <li *ngIf="vod.duration && vod.duration > 0">{{vod.duration | duration}}</li>
                                <li>
                                  <tyt-comments-count [identifier]="'vod_' + vod.id"></tyt-comments-count>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </a>
                    </ng-container>
                  </ng-container>
              </div>
            </div>
          </ng-container>

          <!-- REPORTING -->

          <ng-container *ngSwitchCase="'reporting'">
            <div class="home-row full" [attr.data-shutter-order]="i">
              <div class="row-title">
                <label>
                  <a routerLink="/articles">
                    Original Reporting
                  </a>
                </label>
                <div class="spacer"></div>
                <div class="action-buttons">
                  <a routerLink="/articles">
                    <i class="fas fa-external-link-alt"></i>
                    More
                  </a>
                </div>
              </div>
              <div class="articles-container">
                <ng-container *ngFor="let article of articles; let i = index">
                  <div class="list-divider">
                    <tyt-article-view [article]="article" [homePageStyling]="true">
                    </tyt-article-view>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <ng-container *ngIf="isDevelopment">
              <div class="home-row full" [attr.data-shutter-order]="i">
                <div class="row-title">
                  <label>
                    Unknown Module <code>{{row.type}}</code>
                  </label>
                  <div class="spacer"></div>
                </div>

                <tyt-staging-note>
                  This home page row (with type <code>{{row.type}}</code>) is not implemented.<br/>
                  Details:
                  <pre>{{row | json}}</pre>
                </tyt-staging-note>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <div class="failed-to-load" *ngIf="failedToLoad">
    <h1>Uh oh...</h1>
    <p>Looks like we're having trouble loading this right now.</p>

    <br/>
    <br/>

    <a href="https://youtube.com/the-young-turks" class="fail-alt-card">
      <div class="image"></div>
      <div>
        The Young Turks on YouTube
      </div>
    </a>
    <a href="https://help.tyt.com/" class="fail-alt-card">
      <i class="far fa-life-ring"></i>
      <div>
        Get Help
      </div>
    </a>
    <a href="https://twitter.com/tyt" class="fail-alt-card">
      <i class="fab fa-twitter"></i>
      <div>
        @TYT on Twitter
      </div>
    </a>
  </div>
</load-guard>
